/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

export interface ApiResponse<T = any> {
  success: boolean;
  status: number;
  message?: string;
  data: T;
  length: number;
  error?: Array<FieldError>;
  config?: any;
}
export interface FieldError {
  field: string;
  message: string;
}

export class ApiResponseError {
  status: number;
  message?: string;
  error?: Array<FieldError>;

  constructor(response: any) {
    this.status = response.status;
    this.message = response.message;
    this.error = response.error;
  }

  getErrorMessage() {
    if (this.message) {
      return this.message;
    }

    return this.error?.map(describeFieldError).join('; ') || undefined;
  }
}

const describeFieldError = ({ field, message }: FieldError) => {
  const initial = message.charAt(0);
  const startsLowercase = initial !== initial.toUpperCase();
  return field && startsLowercase ? `${field}: ${message}` : message;
};
